import { useQuery, useMutation } from "react-query";
import { Session, FirebaseSession } from "../types";
import firebase from "firebase";
import moment from "moment";
import { useState } from "react";

const DEFAULT_SESSION: Session = {
  id: "",
  name: "",
  description: "",
  startTime: +moment(),
  finishTime: +moment().add(1, "week"),
  stars: 150,
  isVisible: false,
  videoLink: "",
  teachers: [],
  resources: [],
};

const useSessions = () => {
  const [courses, setCourses] = useState<string[]>();
  const { isLoading, error, data, refetch } = useQuery<Session[]>(
    "sessions",
    () =>
      firebase
        .firestore()
        .collection("sessions")
        .get()
        .then((snapshot) => {
          const sessions: Session[] = [];
          snapshot.forEach((doc) => {
            const data = doc.data() as FirebaseSession;
            sessions.push({
              ...data,
              id: doc.id,
              startTime: data.startTime?.toMillis
                ? data.startTime?.toMillis()
                : undefined,
              finishTime: data.finishTime?.toMillis
                ? data.finishTime?.toMillis()
                : undefined,
            });
          });
          setCourses(
            sessions
              .map((x) => x.course)
              .filter(Boolean)
              .filter(
                (value, index, self) => self.indexOf(value) === index
              ) as string[]
          );
          return sessions;
        })
  );

  const { mutate: removeSession } = useMutation(
    "sessions",
    async (sessionId: string) => {
      await firebase
        .firestore()
        .collection("sessions")
        .doc(sessionId)
        .delete()
        .then(() => refetch());
    }
  );

  const { mutate: addSessionToFirebase } = useMutation(
    "sessions",
    async (variables: Partial<Session>) => {
      await firebase
        .firestore()
        .collection("sessions")
        .doc(variables.id)
        .set({
          ...DEFAULT_SESSION,
          ...variables,
          startTime: new Date(variables?.startTime || Date.now()),
          finishTime: new Date(variables.finishTime || Date.now()),
        })
        .then(() => refetch());
      return variables;
    }
  );

  return {
    isLoading,
    error,
    data,
    addSessionToFirebase,
    removeSession,
    courses,
  };
};

export default useSessions;
